import { createReducer, on } from '@ngrx/store';
import * as actions from '../actions/search.action';
import { FlattenGraphQl } from '../../../utility/graphql-flatten.utility';
import { Product, ProductThumb } from '../../models';

export interface SearchState {
  results: Product[];
  globalResults: ProductThumb[];
  globalSearchLoading: boolean;
  globalSearchLoaded: boolean;
  searchQuery?: string;
  globalSearchQuery?: string;
  pageInfo?: {
    cursor: string;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
  loaded: boolean;
  loading: boolean;
  error?: any;
}

export const initialState: SearchState = {
  results: [],
  globalResults: [],
  globalSearchLoading: false,
  globalSearchLoaded: false,
  pageInfo: {
    cursor: '',
    hasNextPage: false,
    hasPreviousPage: false,
  },
  loaded: false,
  loading: false,
  searchQuery: '',
  globalSearchQuery: '',
};

export const SearchReducer = createReducer(
  initialState,
  on(actions.GlobalSearch, (state: SearchState, { searchQuery }) => {
    return {
      ...state,
      globalResults: [],
      globalSearchLoaded: false,
      globalSearchLoading: true,
      error: null,
      globalSearchQuery: searchQuery,
    };
  }),
  on(actions.EmptyGlobalSearch, (state: SearchState) => {
    return {
      ...state,
      globalResults: [],
      globalSearchQuery: '',
      globalSearchLoaded: true,
      globalSearchLoading: false,
    };
  }),
  on(actions.GlobalSearchSuccess, (state: SearchState, { products }) => {
    const prods = products?.edges.map((e: { node: any }) => FlattenGraphQl(e.node));

    return {
      ...state,
      globalResults: [...prods],
      globalSearchLoaded: true,
      globalSearchLoading: false,
    };
  }),
  on(actions.GlobalSearchFail, (state: SearchState, { error }) => {
    return {
      ...state,
      globalSearchLoaded: false,
      globalSearchLoading: false,
      error,
    };
  }),
  on(actions.LoadSearchResults, (state: SearchState, { searchQuery }) => {
    return {
      ...state,
      searchQuery: searchQuery,
      loaded: false,
      loading: true,
      error: null,
    };
  }),
  on(actions.LoadSearchResultsSuccess, (state: SearchState, { products, loadMore }) => {
    const prods = products?.edges.map((e: { node: any }) => FlattenGraphQl(e.node));
    return {
      ...state,
      results: loadMore ? [...state.results, ...prods] : [...prods],
      pageInfo: {
        cursor: products?.pageInfo.endCursor || products?.edges[products?.edges.length - 1]?.cursor || state?.pageInfo?.cursor || '',
        hasNextPage: products?.pageInfo.hasNextPage,
        hasPreviousPage: products?.pageInfo.hasPreviousPage,
      },
      loading: false,
      loaded: true,
    };
  }),
  on(actions.LoadSearchResultsFail, (state: SearchState, { error }) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      error,
    };
  })
);

export const getSearchResults = (state: SearchState) => state.results;
export const getGlobalSearchResults = (state: SearchState) => state.globalResults;
export const getSearchPageInfo = (state: SearchState) => state.pageInfo;

export const getGlobalSearchLoading = (state: SearchState) => state.globalSearchLoading;
export const getGlobalSearchLoaded = (state: SearchState) => state.globalSearchLoaded;

export const getSearchLoading = (state: SearchState) => state.loading;
export const getSearchLoaded = (state: SearchState) => state.loaded;

export const getSearchError = (state: SearchState) => state.error;
export const getSearchQuery = (state: SearchState) => state.searchQuery;
export const getGlobalSearchQuery = (state: SearchState) => state.globalSearchQuery;
